import React, {useState} from 'react';

import styled from 'styled-components'

import SideBar from '../Components/SideBar';


const HEADER = styled.section`
z-index: 30;
@media screen and (min-width: 48rem) {
    display: none;
}
 
position: relative;

 
 

& h1 {
    text-align: center;
    text-transform: capitalize;
    font-size: 24px;
    font-weight: bold;
    padding-top: 2.5rem;
    color: #451E5E;
    text-shadow: 2px 2px silver;
    line-height: 20px;
  }

  & h5 {
      position: fixed;
      left: 1.2rem;
      top: 1.65rem; 
      height: ${props => props.showMe === "showMe" ? '100vh' : ""};
      width: ${props => props.showMe === "showMe" ? '100vw ' : ""};
     
      @media screen and (min-width: 48rem) {
          display: none;
      }

     }
   
           
& h5 span {
    width: 30px;
    height: 2px;
    background: #0186cb;
    display: block;
    border-radius: 4px;
    margin-bottom: .4rem;
    transition: all 1.1s cubic-bezier(0.455, 0.03, 0.515, 0.955);
    mix-blend-mode: difference;
    font-weight: bolder;

}
 
 
`
const MobileNav = () => {
    const[side, setSide] = useState('')

    let spanStyles = {
        spanFirst: {
            transform: "rotate(45deg) translateY(.2rem)",
            transition: "all 1s  cubic-bezier(0.785, 0.135, 0.15, 0.76)",
            background: "red",
        },
        spanSec: {
            transform:"translateY(-0.9rem) translateX(0.2rem) rotate(-75deg)",
            transition: "all 2.5s  cubic-bezier(0.885, 0.135, 0.15, 0.86)",
            background: "blue",
            zIndex: "4",
            opacity: "0",
        },
        spanThird: {
            transform:"translateY(-0.9rem) translateX(-0.2rem) rotate(-45deg)",
            transition: "all 1s  cubic-bezier(0.785, 0.135, 0.15, 0.76)",
            background: "red",
            zIndex: "2",
        }
    }
    return ( 
        <>
<HEADER showMe={side}>
     <h5 className="meSpan" onClick={() => side === '' ? setSide("showMe") : setSide('')}>
         
        <span style={side === "showMe" ? spanStyles.spanFirst : {display: "block"} }></span>
        <span style={side === "showMe" ? spanStyles.spanSec : {display: "block"} }></span>
        <span style={side === "showMe" ? spanStyles.spanThird : {display: "block"} }></span>

        </h5>  
     
 </HEADER>
 <SideBar showMe = {side} />

        </>
     );
}
 
export default MobileNav;